import { Box, Typography } from "@mui/material";
import ProgressBar from "./ProgressBar";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import { CustomCheckbox } from "../Common/CustomCheckbox";
import axiosInstance from "../../utils/config/config";

const interestLabels = {
  jiuJitsu: "Jiu-Jitsu",
  boxing: "Boxing",
  muaythai: "Muay Thai",
  wrestling: "Wrestling",
  kickboxing: "Kickboxing",
  mma: "MMA Training",
  strength: "Strength & Conditioning",
  mental: "Mental & Recovery",
  fighter: "Fighter Lifestyle",
};

const joiningReasonLabels = {
  training: "Training Content",
  tutorials: "Tutorials",
  professionalAccess: "Professionals Access",
  replays: "Replays",
  behindTheScenes: "Behind-the-Scenes",
};

const Interests = ({
  setStep,
  progress,
  setProgress,
  formData,
  setFormData,
}) => {
  const finalizeSignUp = async () => {
    try {
      const response = await axiosInstance.post(`/user/finalizeSignUp`, {
        user: formData.user,
      });

      if (response) {
        localStorage.setItem("startTour", "true"); // Store tour trigger
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleInterestChange = (updatedInterests) => {
    setFormData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        interests: Object.keys(interestLabels).reduce((acc, key) => {
          acc[key] = updatedInterests.includes(interestLabels[key]);
          return acc;
        }, {}),
      },
    }));
  };

  const handleJoiningReasonChange = (updatedReasons) => {
    setFormData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        joiningReason: Object.keys(joiningReasonLabels).reduce((acc, key) => {
          acc[key] = updatedReasons.includes(joiningReasonLabels[key]);
          return acc;
        }, {}),
      },
    }));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={4}>
      <Box width={{ xs: "90vw", md: "70vw" }}>
        <Typography
          sx={{ fontWeight: "400", fontSize: "32px", mb: 2, textAlign: "left" }}
        >
          Almost Done...
        </Typography>
        <ProgressBar progress={progress} setProgress={setProgress} />
      </Box>

      <Box width={{ xs: "90vw", md: "70vw" }} mt={4}>
        <Typography variant="h6" fontWeight="bold" textAlign="left">
          Interests
        </Typography>
        <CustomCheckbox
          options={Object.values(interestLabels)}
          selectedValues={Object.keys(formData.user.interests)
            .filter((key) => formData.user.interests[key])
            .map((key) => interestLabels[key])}
          onChange={handleInterestChange}
          multiple
        />

        <Typography variant="h6" fontWeight="bold" textAlign="left" mt={3}>
          Reason for Joining
        </Typography>
        <CustomCheckbox
          options={Object.values(joiningReasonLabels)}
          selectedValues={Object.keys(formData.user.joiningReason)
            .filter((key) => formData.user.joiningReason[key])
            .map((key) => joiningReasonLabels[key])}
          onChange={handleJoiningReasonChange}
          multiple
        />

        <Box display="flex" flexDirection="row" gap={5} mt={4}>
          <SecondaryBtn
            text="Previous"
            noIcon
            width="40%"
            onClick={() => setStep(1)}
          />
          <CustomBtn
            text="Next"
            noIcon
            width="40%"
            onClick={() => {
              setProgress(60);
              finalizeSignUp();
              setStep(4);
            }}
          />
        </Box>
        <Box display="flex" flexDirection="row" gap={5}>
          <CustomBtn text="Save" noIcon width="40%" />
        </Box>
      </Box>
    </Box>
  );
};

export default Interests;
